import React, { FC } from 'react'
import { NewsModel } from '@store/slices/news.slice'
import { BsMusicNote } from 'react-icons/bs'
import { useTheme } from '@config/theme.config'
import { Editable, RenderLeafProps, Slate, withReact } from 'slate-react'
import { createEditor } from 'slate'

export interface NewsViewProps {
  news: NewsModel
  minHeight?: number
}

const NewsViewComponent: FC<NewsViewProps> = ({ news, minHeight=0}) => {
  const { theme } = useTheme()

  const editor = withReact(createEditor())
  const initialValue = JSON.parse(news.content ? news.content : '[{"text":""}]')
  const CustomElement = (props: any) => {
    switch (props.element.type) {
      case 'bold':
        return <strong {...props.attributes}>{props.children}</strong>
      case 'audio':
        return (
          <div className="d-flex my-1 w-100" {...props.attributes}>
            <div className="d-flex py-1 px-5 justify-content-center align-items-center text-bg-secondary w-100">
              <span className={'text-nowrap'}>
                <BsMusicNote></BsMusicNote> {props.element.audioName}
                <BsMusicNote></BsMusicNote>
              </span>
              <span className={'text-nowrap'}>
                {props.element.audioStartWords}...
              </span>

              <span className={'text-nowrap'}>
                ...{props.element.audioEndWords}
              </span>
            </div>
          </div>
        )
      default:
        return <span {...props.attributes}>{props.children}</span>
    }
  }

  const renderLeaf = (props: RenderLeafProps) => {
    // @ts-ignore
    if (props.leaf.bold) {
      return <strong {...props.attributes}>{props.children}</strong>
    }
    return <span {...props.attributes}>{props.children}</span>
  }
  return (
    <div
      style={{
        minHeight: `${minHeight}px`,
      }}
    >
      <Slate editor={editor} initialValue={initialValue}>
        <Editable
          renderElement={CustomElement}
          renderLeaf={renderLeaf}
          readOnly={true}
          style={{
            borderRadius: '0.25rem',
            fontSize: '1rem',
            lineHeight: '1.2',
            color: theme === 'light' ? '#000' : '#fff',
            minHeight: '100%',
            maxHeight: '100%',
            margin: 'auto 0',
            display: 'flex',
            flexDirection: 'column',
          }}
        />
      </Slate>
    </div>
  )
}

export default NewsViewComponent
